<template lang="html">
  <div class="Loader-container">
    <pulse-loader :color="spinnerColor" class="Loader"></pulse-loader>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'loader',
  components: {
    PulseLoader
  },
  data () {
    return {
      spinnerColor: '#f0f0f0'
    }
  }
}
</script>

<style lang="css">
.Loader-container {
  height: 100vh;
  position: relative;
}

.Loader {
  position: absolute;
  top: 10%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/Loader.vue